import { numericExtent, mfiSeries } from "../utils";
const MFI = {
    name: "MFI",
    compute: (bars, period = 14) => mfiSeries(bars, period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default MFI;
